import { apiFetch } from './client'
import { cached, invalidatePrefix } from './cache'

export interface Payment {
  id: string
  user_id?: string
  client_name?: string
  membership_id?: string
  plan_name?: string
  payment_type_id?: string
  payment_method_id?: string
  discount_id?: string
  amount: number
  discount_amount: number
  currency: string
  status: string
  reference?: string
  notes?: string
  paid_at: string
}

export interface CreatePaymentInput {
  userId?: string
  clientName?: string
  membershipId?: string
  paymentTypeId?: string
  paymentMethodId?: string
  discountId?: string
  discountCode?: string
  amount: number
}

export interface UpdatePaymentInput {
  amount?: number
  paymentMethodId?: string
  notes?: string
}

export interface PaymentsPage {
  payments: Payment[]
  total: number
  limit: number
  offset: number
}

export const getPayments = (userId?: string, limit = 100, offset = 0) => {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset) })
  if (userId) params.set('userId', userId)
  const cacheKey = `payments:${params}`
  return cached<PaymentsPage>(cacheKey, () => apiFetch<PaymentsPage>(`/payments?${params}`), 60_000)
}

export const createPayment = async (data: CreatePaymentInput) => {
  const r = await apiFetch<{ payment: Payment }>('/payments', { method: 'POST', body: JSON.stringify(data) })
  invalidatePrefix('payments:')
  return r
}
export const updatePayment = async (id: string, data: UpdatePaymentInput) => {
  const r = await apiFetch<{ payment: Payment }>(`/payments/${id}`, { method: 'PATCH', body: JSON.stringify(data) })
  invalidatePrefix('payments:')
  return r
}
export const deletePayment = async (id: string) => {
  const r = await apiFetch<{ ok: boolean }>(`/payments/${id}`, { method: 'DELETE' })
  invalidatePrefix('payments:')
  return r
}
